export class ArrayUtils {

    static orderByKey(array, key) {
        return array.sort((a, b) => {
            if (a[key] > b[key]) return 1;
            else if (a[key] < b[key]) return -1;

            return 0;
        });
    }

    /**
     * Ordena por la primera key, si son iguales mira la segunda, etc.
     * @param array
     * @param keys
     * @returns {*}
     */
    static orderByKeys(array, keys) {
        return array.sort((a, b) => {

            for (let key of keys) {
                if (a[key] > b[key]) return 1;
                else if (a[key] < b[key]) return -1;
            }

            return 0;
        });
    }
}